export default {
  "Blood Specimens": [
    "Whole blood",
    "Serum",
    "Plasma",
    "Blood spots (e.g., Guthrie test for newborns)",
  ],
  "Urine Specimens": [
    "Random urine",
    "First morning urine",
    "24-hour urine collection",
    "Timed urine (e.g., 2-hour, postprandial)",
    "Catheterized urine",
    "Suprapubic aspirated urine",
  ],
  "Stool (Fecal) Specimens": [
    "Fresh stool (for parasites, culture)",
    "Preserved stool (with formalin/SAF for parasites)",
    "Occult blood stool sample",
  ],
  "Respiratory Specimens": [
    "Expectorated sputum",
    "Induced sputum",
    "Bronchoalveolar lavage (BAL)",
    "Throat swab",
    "Nasal swab",
    "Nasopharyngeal swab/aspirate",
    "Tracheal aspirate",
  ],
  "Cerebrospinal Fluid (CSF)": ["Lumbar puncture sample"],
  "Body Fluids": [
    "Pleural fluid (lungs)",
    "Pericardial fluid (heart)",
    "Peritoneal/ascitic fluid (abdomen)",
    "Synovial fluid (joints)",
  ],
  "Tissue and Cell Specimens": [
    "Biopsy specimens (e.g., liver, kidney, skin, tumor)",
    "Surgical specimens (excised organs/tissues)",
    "Cytology specimens (fine-needle aspirates, Pap smear)",
    "Bone marrow aspirates/biopsy",
  ],
  "Genital & Reproductive Specimens": [
    "Cervical swab / Pap smear",
    "Vaginal swab",
    "Urethral swab",
    "Semen sample",
    "Endometrial biopsy",
  ],
  "Prenatal & Neonatal Specimens": [
    "Amniotic fluid (via amniocentesis)",
    "Chorionic villus sample (CVS)",
    "Cord blood (at delivery)",
    "Heel prick blood spots (newborn screening)",
  ],
  "Dermatological Specimens": [
    "Skin scrapings (fungal studies)",
    "Hair (toxicology, fungal culture)",
    "Nails (fungal studies, toxicology)",
  ],
  Miscellaneous: [
    "Wound swabs/pus aspirates",
    "Abscess aspirates",
    "Catheter tips",
    "Foreign bodies (stones, devices for analysis)",
  ],
};
